import { IonCol, IonGrid, IonImg, IonRow, IonText } from '@ionic/react';

import { QuickLinkCard, QuickLinkCardProps } from '@/components/QuickLinkCard';

import { isProduction } from '@/utils/environment';
import { mergeClassNames } from '@/utils/mergeClassNames';

import QuickLinkBg from '@/assets/bg-pattern-grid.png';

import styles from './index.module.css';

export const QuickLinkGrid = () => {
  const content = [
    {
      id: '5dbd1879-cb83-439b-8e93-95d85bc2d5c5',
      icon: 'document',
      color: 'green',
      text: 'View reports',
      routerLink: '/reports',
      routerDirection: 'forward',
      showOn: 'production',
    },
    {
      id: '5ad49038-4eae-452b-b686-1997e983220c',
      icon: 'upload',
      color: 'yellow',
      text: 'Upload new file',
      routerLink: '/upload',
      routerDirection: 'forward',
      showOn: 'production',
    },
    {
      id: '6494d3eb-761b-49df-816e-4cbdac2b87e7',
      icon: 'chart',
      color: 'teal',
      text: 'Add new measurements',
      onClick: () => {
        console.log('add new measurements');
      },
      showOn: 'development',
    },
  ] satisfies Array<{ id: string; text: string } & QuickLinkCardProps>;

  const filteredItemsByEnvironment = content.filter((item) => {
    if (isProduction) {
      return item.showOn === 'production';
    }
    return item;
  });

  return (
    <IonGrid className={styles.wrapper}>
      <IonRow>
        <IonCol className={mergeClassNames(styles.col, styles.header)} size='12'>
          <IonText className={styles.heading}>Quicklinks</IonText>
        </IonCol>
      </IonRow>

      <IonRow className={styles.row}>
        {filteredItemsByEnvironment.map(({ id, text, ...item }) => (
          <IonCol className={styles.col} key={id}>
            <QuickLinkCard {...item}>{text}</QuickLinkCard>
          </IonCol>
        ))}
      </IonRow>
      <IonImg className={styles.background} src={QuickLinkBg} />
    </IonGrid>
  );
};
